import Zendesk from "react-zendesk";
import React, { useContext } from "react";
import UserContext from "../contexts/userContext";
import RemoteConfigContext from "../contexts/remoteConfigContext";
import { getZendeskAuthToken } from "../actions";

const ZendeskWrapper: React.FC = () => {
	const { zendesk } = useContext(RemoteConfigContext);
	const { language, userId, profile } = useContext(UserContext);

	if (!zendesk || !userId) {
		return null;
	}

	const settings = {
		webWidget: {
			setLocale: language || "de",
			authenticate: {
				jwtFn: function(callback: (token: string) => void) {
					getZendeskAuthToken().then(token => {
						callback(token);
					});
				},
				chat: {
					jwtFn: function(callback: (token: string) => void) {
						getZendeskAuthToken().then(token => {
							callback(token);
						});
					},
				},
			},
		},
	};

	return <Zendesk defer={false} zendeskKey={process.env.REACT_APP_ZENDESK_KEY} {...settings} />;
};

export default ZendeskWrapper;
